import { AppThunk } from "../../../store";
import { setRefactoredCollapsedCategoryIdsInRedux, setRefactoredExpandedCategoryIdsInRedux } from "./checklistSlice";

type RefactoredCategoryCollapseState = {
  allCategoriesCollapsed: boolean;
  categoryIds: string[];
  collapsedCategoryIds: Set<string>;
};

const setRefactoredCategoryCollapseState =
  (
    categoryIds: string[],
    collapsed: boolean,
    refactoredCollapsedCategoryIds: string[],
    refactoredExpandedCategoryIds: string[],
  ): AppThunk =>
  (dispatch) => {
    const categoryIdSet = new Set(categoryIds);

    if (collapsed) {
      dispatch(
        setRefactoredCollapsedCategoryIdsInRedux([
          ...new Set([...refactoredCollapsedCategoryIds, ...categoryIds]),
        ]),
      );
      dispatch(
        setRefactoredExpandedCategoryIdsInRedux(refactoredExpandedCategoryIds.filter((id) => !categoryIdSet.has(id))),
      );
      return;
    }

    dispatch(setRefactoredExpandedCategoryIdsInRedux([...new Set([...refactoredExpandedCategoryIds, ...categoryIds])]));
    dispatch(
      setRefactoredCollapsedCategoryIdsInRedux(
        refactoredCollapsedCategoryIds.filter((id) => !categoryIdSet.has(id)),
      ),
    );
  };

export const thunkToggleRefactoredCategoryCollapse =
  (
    categoryId: string,
    collapseState: RefactoredCategoryCollapseState,
    refactoredCollapsedCategoryIds: string[],
    refactoredExpandedCategoryIds: string[],
  ): AppThunk =>
  (dispatch) => {
    dispatch(
      setRefactoredCategoryCollapseState(
        [categoryId],
        collapseState.collapsedCategoryIds.has(categoryId) === false,
        refactoredCollapsedCategoryIds,
        refactoredExpandedCategoryIds,
      ),
    );
  };

export const thunkToggleAllRefactoredCategoriesCollapse =
  (
    collapseState: RefactoredCategoryCollapseState,
    refactoredCollapsedCategoryIds: string[],
    refactoredExpandedCategoryIds: string[],
  ): AppThunk =>
  (dispatch) => {
    dispatch(
      setRefactoredCategoryCollapseState(
        collapseState.categoryIds,
        collapseState.allCategoriesCollapsed === false,
        refactoredCollapsedCategoryIds,
        refactoredExpandedCategoryIds,
      ),
    );
  };
